import { Reaction } from 'features/room-reactions/types';

import thumbsUpSvg from 'assets/images/emojis/thumbs_up.svg';
import redHeartSvg from 'assets/images/emojis/red_heart.svg';
import clappingHandsSvg from 'assets/images/emojis/clapping_hands.svg';
import grinningFaceSvg from 'assets/images/emojis/grinning_face.svg';
import partyPopperSvg from 'assets/images/emojis/party_popper.svg';
import thumbsDownSvg from 'assets/images/emojis/thumbs_down.svg';
import sadFaceSvg from 'assets/images/emojis/sad_face.svg';
import angryFaceSvg from 'assets/images/emojis/angry_face.svg';

export const EMOJIS_LIST: Reaction[] = [
  'thumbs_up',
  'red_heart',
  'clapping_hands',
  'grinning_face',
  'party_popper',
  'thumbs_down',
  'sad_face',
  'angry_face',
];

export const EMOJI_ICONS: Record<Reaction, string> = {
  thumbs_up: thumbsUpSvg,
  red_heart: redHeartSvg,
  clapping_hands: clappingHandsSvg,
  grinning_face: grinningFaceSvg,
  party_popper: partyPopperSvg,
  thumbs_down: thumbsDownSvg,
  sad_face: sadFaceSvg,
  angry_face: angryFaceSvg,
};

export const EMOJI_WIDTH = 60;

export const LANE_WIDTH = 80;

export const MIN_LANES = 1;

export const MAX_LANES = 5;

export const NAME_CHIP_MAX_WIDTH = 160;

export const LANE_COOLDOWN_MS = 1000;

export const REACTION_DISPLAY_DURATION_MS = 15000;

export const REACTIONS_ZONE_MAX_WIDTH = 400;

export const REACTIONS_ZONE_LEFT_INSET = 20;

export const CHIP_WIDTH_CONTAINER_RATIO = 0.8;

export const NEIGHBOR_STAGGER_MS = 350;

export const NEIGHBOR_STAGGER_WINDOW_MS = 500;
